import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Layout.css";

const Layout = () => {
  return (
    <div className="layout">
      <Navbar />
      <main className="content">
        <Outlet /> {/* 👈 This renders the nested page (Dashboard, Capture, etc.) */}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
